import { Component } from 'react';

import EditProfileForm from './edit-profile-form';

import './edit-profile-section.css';

class EditProfileSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_edit_form: false,
    };
  }

  showEditForm() {
    this.setState({
      show_edit_form: true,
    });
  }

  hideEditForm() {
    this.setState({
      show_edit_form: false,
    });
  }

  render() {
    const { player, update_home_user } = this.props;

    const { show_edit_form } = this.state;

    return (
      <div className="edit_profile_section">
        {show_edit_form && (
          <EditProfileForm
            player={player}
            hide_func={this.hideEditForm.bind(this)}
            show={show_edit_form}
            update_home_user={update_home_user}
          />
        )}
        <div className="edit_profile_section_title">Home Play</div>
        <button className="show_edit_profile_form" onClick={this.showEditForm.bind(this)}>
          Edit Profile
        </button>
      </div>
    );
  }
}

export default EditProfileSection;
